module.exports = __webpack_public_path__ + "img/new05_en.0e4e94dc.png";